import React, { useLayoutEffect, useRef } from "react";
import { useState } from "react";
import gsap from "gsap";

export default function Contact() {

const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    organization: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name.toLowerCase()]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus("loading");

    try {
      const res = await fetch("https://mystra.in/apiMail/pthrup-contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.status === "success") {
        setStatus("success");
        setFormData({
          name: "",
          email: "",
          contact: "",
          organization: "",
          message: "",
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  const contactref = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

      // Heading animation
      tl.from(".contact-small-title", {
        y: 60,
        opacity: 0,
        duration: 0.9,
      });

      tl.from(".contact-big-title", {
        y: 80,
        opacity: 0,
        duration: 1,
      }, "-=0.5");

      tl.from(".contact-desc", {
        opacity: 0,
        y: 30,
        duration: 0.8,
      }, "-=0.6");

      tl.from(".contact-underline", {
        width: 0,
        duration: 1.2,
      }, "-=0.4");

      // Team cards
      tl.from(".team-card", {
        y: 80,
        opacity: 0,
        stagger: 0.25,
        duration: 1,
      }, "-=0.6");

      // Contact links stagger
      tl.from(".contact-link", {
        y: 20,
        opacity: 0,
        stagger: 0.15,
        duration: 0.7,
      }, "-=0.8");

      // Location block
      tl.from(".location-block", {
        y: 50,
        opacity: 0,
        duration: 1,
      }, "-=0.6");

      // Form slide from right
      tl.from(".contact-form", {
        x: 120,
        opacity: 0,
        duration: 1.2,
      }, "-=1");

    }, contactref);

    return () => ctx.revert();
  }, []);

  return (
    <div className="main-wrapper">
 <section className="section is-contact-hero" ref={contactref}>
    <div className="container-lg is-pad">
        <div className="flex-v-l is-m-heading is-contact">
            <div className="h1-sm-wrap">
                <h1 className="h1-sm">We’re Here</h1>
            </div>
            <div className="h1-s-wrap">
                <h1 className="h1-ss">to assist you</h1>
                <div className="cont-ab">
                    <p className="text">Get in touch with the Pthrup team to receive expert Foodsafe solutions tailored to your industry needs.
</p>
                </div>
            </div>
            <div className="cont-ab is-mobile">
                <p className="text">Get in touch with the Pthrup team to receive expert Foodsafe solutions tailored to your industry needs.
</p>
            </div>
        </div>
        {/* <div className="h-underline is-ss"></div> */}
    </div>
    <div className="container-lg is-pad is-contact">
        <div className="flex-split-top">
            <div className="flex-v contact-content">
                <div className="w-dyn-list">
                    <div role="list" className="flex-l-s w-dyn-items">
                        <div role="listitem" className="collection-item-3 w-dyn-item">
                            <div className="flex-v-l d-80 is-contact">
                               
                                <div className="contact-link-wrapper">
                                     <div className="contact-h3">Call or WhatApp us now:<br/></div>
                                     <a href="https://api.whatsapp.com/send?phone=919819424709 &text=Hello" target="_blank" rel="noopener noreferrer">
                                        <div className="link-wrap is-contact"><h3
                                            className="link"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                                            </svg> (+91) 9819424709  </h3>
                                        </div>
                                     </a>
                               
                                    
                                     <div className="contact-h3 is-margin-top ">Mail:<br/></div>
                                    <div className="link-wrap is-contact">
                                        <h3 className="link is-no-link">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at-fill" viewBox="0 0 16 16">
                                        <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671"/>
                                        <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791"/>
                                        </svg> akshay@pthrup.com.</h3>
                                    </div>
                                 
                            </div>
                        </div>
                    </div>
                    
            </div>
        </div>
        <div className="h-divider"></div>
        <div className="flex-l-s is-contact">
            <div className="flex-v-l d-50">
                <div className="contact-h3">Find Us<br/></div>
                <div className="contact-link-wrapper is-location w-inline-block">
                    <div className="link-wrap is-contact">
                        <div className="link"><strong>Unit 1 - </strong> A 292/2 6th main, Second stage, Peenya,</div>
                    </div>
                    <div className="link-wrap is-contact">
                        <div className="link">Bengaluru - 560058, Karnataka, India. </div>
                    </div>
                </div>
            
                <div className="contact-link-wrapper is-location w-inline-block">
                    <div className="link-wrap is-contact">
                        <div className="link"><strong>Unit 2 - </strong>SF No. 471/1A1, Balaji Industrial Park,</div>
                    </div>
                    <div className="link-wrap is-contact">
                        <div className="link">
                            Sendhampalayam, Coimbatore - 641107, Tamil Nadu, India
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="form-block w-form">
        <form id="email-form"  onSubmit={handleSubmit} className="form" aria-label="Email Form">
            <div className="flex-v is-form">
                <div className="flex-l-s is-form-flex">
                    <div className="input-field"><input className="text-field w-input" maxlength="256" name="name"
                            data-name="Name" placeholder="YOUR FULL NAME" type="text" id="name" value={formData.name} onChange={handleChange} required />
                            </div>
                    <div className="input-field"><input className="text-field w-input" maxlength="256" name="Email"
                            data-name="email" placeholder="YOUR EMAIL" type="email" id="email" value={formData.email} onChange={handleChange} required 
                           /></div>
                </div>
                <div className="flex-l-s is-form-flex">
                    <div className="input-field"><input className="text-field w-input" maxlength="256" name="contact"
                            data-name="contact" placeholder="CONTACT NO" type="tel" id="contact" value={formData.contact} onChange={handleChange} required
                          /></div>
                    <div className="input-field"><input className="text-field w-input" maxlength="256" name="organization"
                            data-name="organization" placeholder="YOUR ORGANIZATION" type="text" id="organization"
                            value={formData.organization} onChange={handleChange} /></div>
                </div><textarea placeholder="TYPE YOUR MESSAGE" maxlength="5000" id="message" name="message"
                    data-name="message" className="text-field is-msg w-input" value={formData.message} onChange={handleChange}/>
            </div>
            {/* <input type="submit" data-wait="Please wait..." className="form-btn w-button" value="Submit"/> */}

             <button type="submit" className="form-btn w-button">
                {status === "loading" ? "Please wait..." : "Submit"}
            </button>
            <div>
                <div>
                    {/* <input type="hidden" name="cf-turnstile-response" id="cf-chl-widget-6iwfd_response"/> */}
                </div>
            </div>
        </form>

        {status === "success" &&  <div className="success-message w-form-done" tabindex="-1" role="region" aria-label="Email Form success"><div className="success-icon-wrapper"><div className="success-icon"></div></div><div className="thank-you--text">Thank you!<br/>Your submission has been received!</div><div className="success-text-wrapper"><div className="text txt-white d-50 is-mobile-change">Our team will get back to you shortly, ususally within 24 - 48 hours. Have a great day!</div></div></div>}
      {status === "error" && <div className="error-message w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure"><div className="thank-you--text is-error">Oops! Something went wrong while submitting the form.</div></div>}
       
        
    </div>
    </div>
    </div>
</section>
    </div>
   
  );
}